export const objectInsertIfUtil = (condition, data) => condition ? data : {};
export default objectInsertIfUtil;
